import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const API = process.env.REACT_APP_API_BASE_URL;

export default function TambahWithdrawAffiliatePage() {
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const [balance, setBalance] = useState(0);

  const [form, setForm] = useState({
    amount: "",
    bank_name: "",
    account_number: "",
    account_name: "",
  });

  const formatPrice = (price: any) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  /*
  ==========================
  GET BALANCE
  ==========================
  */

  const fetchBalance = async () => {
    try {
      const res = await axios.get(`${API}/api/affiliate/balance`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setBalance(res.data.balance);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, []);

  /*
  ==========================
  HANDLE INPUT
  ==========================
  */

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  /*
  ==========================
  TARIK SEMUA
  ==========================
  */

  const tarikSemua = () => {
    setForm({
      ...form,
      amount: balance.toString(),
    });
  };

  /*
  ==========================
  SUBMIT WITHDRAW
  ==========================
  */

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const amountNumber = Number(form.amount);

    if (amountNumber < 10000) {
      Swal.fire({
        icon: "warning",
        title: "Minimal Withdraw Rp 10.000",
      });
      return;
    }

    try {
      const res = await axios.post(
        `${API}/api/affiliate/withdraw`,
        {
          amount: amountNumber,
          bank_name: form.bank_name,
          account_number: form.account_number,
          account_name: form.account_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: res.data.message,
      });

      navigate("/dashboard-affiliate/withdraw");
    } catch (error: any) {
      const message = error?.response?.data?.message || "Terjadi kesalahan";

      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: message,
      });
    }
  };

  return (
    <div className=" max-w-xl mx-auto">
      {/* TITLE */}
      <Link to="/dashboard-affiliate/withdraw" className="flex items-center gap-2 mb-6">
        <IoMdArrowBack />
        <h2 className="text-xl font-bold">Pengajuan Withdraw</h2>
      </Link>

      {/* BALANCE */}
      <div className="bg-green-50 border border-green-200 p-4 rounded-xl mb-6">
        <p className="text-sm text-gray-600">Saldo Tersedia</p>
        <h2 className="text-2xl font-bold text-green-600">Rp {formatPrice(balance)}</h2>
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow space-y-4">
        {/* AMOUNT */}
        <div>
          <label className="text-sm font-medium">Jumlah Withdraw</label>

          <div className="flex gap-2 mt-1">
            <input type="number" name="amount" required min={10000} value={form.amount} onChange={handleChange} className="w-full border rounded-lg p-2" placeholder="Minimal 10.000" />

            <button type="button" onClick={tarikSemua} className="bg-primary text-white px-3 rounded-lg text-sm max-sm:w-[50%] w-[30%]">
              Tarik Semua
            </button>
          </div>
        </div>

        {/* BANK */}
        <div>
          <label className="text-sm font-medium">Bank</label>
          <input type="text" name="bank_name" required value={form.bank_name} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" placeholder="Contoh: BCA" />
        </div>

        {/* ACCOUNT NUMBER */}
        <div>
          <label className="text-sm font-medium">Nomor Rekening</label>
          <input type="text" name="account_number" required value={form.account_number} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* ACCOUNT NAME */}
        <div>
          <label className="text-sm font-medium">Nama Rekening</label>
          <input type="text" name="account_name" required value={form.account_name} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* BUTTON */}
        <div className="flex gap-3 pt-4">
          <button type="submit" className="bg-primary text-white px-6 py-2 rounded-lg hover:opacity-90">
            Ajukan Withdraw
          </button>

          <button type="button" onClick={() => navigate("/affiliate/withdraw")} className="bg-gray-200 px-6 py-2 rounded-lg">
            Batal
          </button>
        </div>
      </form>
    </div>
  );
}
